/* eslint-disable angular/function-type */
angular
  .module('app.notes')
  .factory('notesModal', [
    '$modal',
    function notesModal($modal) {
      return {
        openAddNoteModal: (modalData, Notes, noNotes) => {
          var modalInstance
          modalData.sNotes = Notes
          modalData.note.category = 'Conversation'
          modalInstance = $modal.open({
            templateUrl: 'notesModal.html',
            controller: 'NoteModalController',
            windowClass: 'notes-modal-window',
            resolve: {
              noteData: function() {
                return modalData
              },
            },
          })
          modalInstance.result.then(
            updatedData => {
              updatedData.employer = updatedData.employerId
                ? modalData.employers.find(
                    employer => employer.id === updatedData.employerId
                  )
                : undefined
              updatedData.author = updatedData.authorId
                ? modalData.authors.find(
                    author => author.id === updatedData.authorId
                  )
                : undefined
              updatedData.displayDate = updatedData.created
              // eslint-disable-next-line no-unused-vars
              if (Notes.length === 0) noNotes = false
              Notes.unshift(updatedData)

              return Notes
            },
            () => {}
          )
          return Notes
        },
        openDeleteNoteModal: (noteID, notes, index) => {
          var modalInstance
          modalInstance = $modal.open({
            templateUrl: 'deleteNoteModal.html',
            controller: 'NoteModalController',
            windowClass: 'notes-modal-window',
            resolve: {
              noteData: function() {
                return noteID
              },
            },
          })
          modalInstance.result.then(
            () => {
              notes.splice(index, 1)
              return notes
            },
            () => {}
          )
          return notes
        },
        openEditNoteModal: (notes, index, modalData) => {
          var modalInstance
          modalInstance = $modal.open({
            templateUrl: 'editNoteModal.html',
            controller: 'NoteModalController',
            windowClass: 'notes-modal-window',
            resolve: {
              noteData: function() {
                return modalData
              },
            },
          })
          modalInstance.result.then(
            updatedData => {
              updatedData.employer = updatedData.employerId
                ? modalData.employers.find(
                    employer => employer.id === updatedData.employerId
                  )
                : undefined
              updatedData.author = updatedData.authorId
                ? modalData.authors.find(
                    author => author.id === updatedData.authorId
                  )
                : undefined
              notes[index] = Object.assign({}, updatedData)

              return notes
            },
            () => {}
          )
        },
        openNoteHistoryModal: NoteHistory => {
          var modalInstance
          modalInstance = $modal.open({
            templateUrl: 'noteHistoryModal.html',
            controller: 'NoteModalController',
            resolve: {
              noteData: () => {
                return NoteHistory
              },
            },
          })
          modalInstance.result.then()
          return NoteHistory
        },
      }
    },
  ])
  .factory('lawyerAndAdminID', [
    // eslint-disable-next-line func-names
    function() {
      var factory
      var model
      factory = {}
      model = {}
      // eslint-disable-next-line func-names
      factory.setModel = function(key, value) {
        model[key] = value
      }

      // eslint-disable-next-line func-names
      factory.getModel = function(key) {
        return model[key]
      }

      return factory
    },
  ])



// WEBPACK FOOTER //
// ./scripts/notes/notes-modal.js